import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";

const AccessHomePage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header title={"Manajemen Petugas"} />
      
      <main className="max-w-4xl mx-auto px-6 pt-24 pb-12">
        <div className="mb-10 text-left">
          <h2 className="text-3xl font-extrabold text-slate-900 tracking-tight">
            Manajemen Petugas
          </h2>
          <p className="text-sm text-slate-500 mt-2 font-medium">
            Kelola pendaftaran petugas lapangan dan verifikasi hak akses masuk ke aplikasi mobile PLN Ganti Meter.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Card 1: Tambah Petugas */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600 mb-6">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Tambah Petugas Baru</h3>
              <p className="text-sm text-slate-500 leading-relaxed font-medium">
                Daftarkan akun petugas lapangan baru secara manual dengan mengisi username, password, unit UP, dan nama lengkap.
              </p>
            </div>
            <Link
              to="/add-user"
              className="mt-8 block w-full bg-slate-900 text-white text-center py-2.5 px-4 rounded-xl hover:bg-indigo-600 transition font-semibold text-sm"
            >
              Tambah Petugas
            </Link>
          </div>

          {/* Card 2: Berikan Akses Petugas */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600 mb-6">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Persetujuan Akses</h3>
              <p className="text-sm text-slate-500 leading-relaxed font-medium">
                Verifikasi status pendaftaran, berikan otorisasi izin masuk aplikasi mobile petugas, atau nonaktifkan akun sementara.
              </p>
            </div>
            <Link
              to="/approve-user"
              className="mt-8 block w-full bg-slate-900 text-white text-center py-2.5 px-4 rounded-xl hover:bg-indigo-600 transition font-semibold text-sm"
            >
              Berikan Akses
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AccessHomePage;
